<template>
	<div class="customer-service-page">
		<div v-if="!kfUrl" class="kf-fallback">
			<p class="kf-fallback-text">客服链接未配置，请联系管理员。</p>
		</div>
		<iframe
			v-else
			ref="kfIframe"
			id="kf-iframe"
			class="kf-iframe-el"
			title="在线客服"
			:width="searchTableWidth"
		></iframe>
	</div>
</template>
<script>
import $store from '../../store';
import request from '@utils/request';
import { isKfHttpOnHttpsPage } from '@utils/index';
export default {
	name: '',
	data() {
		return {
			reportUrl: '',
			searchTableHeight: 0,
			searchTableWidth: 0
		};
	},
	computed: {
		kfUrl() {
			return String($store.state.app.kf || '').trim();
		}
	},
	mounted() {
		const kf = this.kfUrl;
		if (kf && isKfHttpOnHttpsPage(kf)) {
			window.location.replace(kf);
			return;
		}
		request.get('/shop/sign/status', {}, { login: true });
		this.searchTableHeight = window.innerHeight;
		this.searchTableWidth = window.innerWidth;
		this.$nextTick(() => this.loadKfInIframe());
	},
	created() {
		// this.reportUrl = this.$storage.get('kf_url')
	},
	watch: {
		$route: function() {
			// 监听路由变化
			//   this.reportUrl =  this.$storage.get('kf_url')
		}
	},
	methods: {
		/**
		 * 直接用 iframe 打开客服地址。不可用 XHR 拉取外站页面：会触发 CORS 预检，
		 * 对方若重定向 OPTIONS 会被浏览器拦截（与 localhost 无关）。
		 */
		loadKfInIframe() {
			const kf = this.kfUrl;
			const el = this.$refs.kfIframe;
			if (!kf) {
				console.warn('客服链接未配置');
				return;
			}
			if (!el) return;
			el.src = kf;
		}
	},
	components: {}
};
</script>

<style scoped lang="less">
.customer-service-page {
	box-sizing: border-box;
	min-height: 100vh;
	padding-bottom: 50px; /* 底部 Tab 占位 */
}
.kf-iframe-el {
	display: block;
	border: none;
	width: 100%;
	/* 视口高度减去底部导航 */
	height: calc(100vh - 50px);
	min-height: 320px;
}

.kf-fallback {
	box-sizing: border-box;
	padding: 24px 18px 80px;
	min-height: calc(100vh - 50px);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
}
.kf-fallback-text {
	margin: 0;
	font-size: 14px;
	color: #888;
	line-height: 1.6;
}
</style>
